<template>
<div v-if="isShow">
    <header>
        違反報告
        <div class="h-left">
            <a @click="$emit('closeReport')"><img src="~@/assets/images/icon01.svg" /></a>
        </div>
    </header>
    <div id="wrap2" style="height: 100vh; overflow: scroll">
        <div class="txt-area2">
            GreedGreedの利用規約に違反していると思われるユーザーを発見した場合は、以下のフォームをご記入の上、ご報告をお願いします。
        </div>

        <div class="txt-area">
            <p class="b">違反報告対象のユーザー</p>
        </div>

        <div class="violation01 clearfix">
            <div class="violation-img">
                <img v-if="userDetail.avatar_url" :src="getImageUrl(getImageUrl(userDetail.avatar_url))" />
                <span v-else>No avatar</span>
            </div>
            <div class="violation02">{{ userDetail.display_name }}</div>
        </div>

        <div class="txt-area" style="padding-bottom: 0">
            <p class="b">違反箇所</p>
        </div>
        <form ref="form">
            <div class="real-select">
                <select v-model="category" required :style="validate(category, 'category') ? validate(category, 'category').style : ''">
                    <option :value="null" selected disabled>選択してください</option>
                    <option v-for="(item, index) in reportCategories" :key="index" :value="item">{{ item }}</option>
                </select>
                <span style="color:red" v-if="validate(category, 'category')">{{ validate(category, 'category').message }}</span>
            </div>
            <div class="txt-area">
                <p class="b">具体的な理由</p>
                <textarea :style="validate(comment, 'comment') ? validate(comment, 'comment').style : ''" required v-model="comment" class="self-introduction1" placeholder="10文字以上ご記入ください"></textarea>
                <span style="color:red" v-if="validate(comment, 'comment')">{{ validate(comment, 'comment').message }}</span>
                <div class="clearfix">
                    <div class="self-introduction3">{{comment ? comment.length : '0'}}/1000</div>
                </div>
                <p class="b red">ご注意</p>
            </div>

            <div class="txt-area2">
                運営事務局にて内容を確認し、利用規約に違反する、または違反する可能性があると思われる場合には、しかるべき処理を取らせて頂きます。<br />
                頂いた報告内容に対して、お問い合わせ頂いても個別にご回答はできかねますので、ご了承ください。
            </div>
            <div style="margin-bottom: 150px;" :class="isSubmit ? 'btn1': 'btn3'" @click="submit"><a>送信</a></div>
        </form>
    </div>
    <successDialog :active="isSuccess" @close="resetForm">
        <template v-slot:title>
            <p>
                違反報告する
            </p>
        </template>
        <template v-slot:message>
            <p>
                {{ message }}
            </p>
        </template>
    </successDialog>
</div>
<loading :active="isLoading" :can-cancel="true" :is-full-page="true"></loading>
</template>

<script>
import {
    mapGetters
} from "vuex"
import successDialog from '@/views/components/successDialog'
import mixin from "@/mixin"
export default {
    props: {
        isShow: Boolean,
        reportCategories: Array,
        userDetail: Object
    },
    components: {
        successDialog
    },
    emits: ["closeReport"],
    mixins: [mixin],
    data: () => ({
        isSubmit: false,
        category: null,
        comment: null,
        isValidate: false,
        isSuccess: false,
        message: null,
        isLoading: false
    }),
    computed: {
        ...mapGetters(['defaultToken']),
    },
    watch: {
        category(data) {
            if (data && this.comment && this.comment.length >= 10) {
                this.isSubmit = true
            } else {
                this.isSubmit = false
            }
        },
        comment(data) {
            if (data && this.category && data.length >= 10) {
                this.isSubmit = true
            } else {
                this.isSubmit = false
            }
        }
    },
    methods: {
        resetForm() {
            this.isSuccess = false
            this.category = null
            this.comment = null
            this.isSubmit = false
            this.isValidate = false
        },
        validate(value, field) {
            if (!this.isValidate) return
            if (field === 'category') {
                if (!value) {
                    return {
                        style: "border-color: red",
                        message: "選択してください"
                    }
                }
            }
            if (field === 'comment') {
                if (!value || value.length < 10) {
                    return {
                        style: "border-color: red",
                        message: "具体的な理由は10文字以上ご記入ください"
                    }
                }
            }
            return
        },
        async submit() {
            this.isValidate = true
            if (!this.isSubmit) return
            let formData = new FormData()
            formData.append('id', this.userDetail.id)
            formData.append('user_code', this.userDetail.user_code)
            formData.append('category', this.category)
            formData.append('comment', this.comment)
            formData.append('token', this.defaultToken)
            this.isLoading = true
            await this.$store.dispatch('user/userReport', formData).then(data => {
                this.isSuccess = true
                this.isLoading = false
                this.message = data.message
            }).catch(err => {
                console.log(err)
            })
        }
    }
};
</script>

<style scoped>
.real-select {
    padding: 3%;
}
.real-select select {
    margin: 0;
    width: 100%;
    margin-bottom: 8px;
}
</style>